<template>
  <div>

    <div
      class="cursor-pointer shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24 h-10 bg-[#ccc] flex justify-center items-center"
      v-if="is_frection" @click="$emit('toggleFrection')">{{
        decimalToFractionNew(disabled ? 0 : this.initValue * this.scale) }}</div>

    <div
      v-else-if="initValue !== null && component_value !== null && scale !== null && scale > 0 && initValue > 0 && !hideValues && recipePortion > 0"
      class="text-left px-6">

      <input type="number" step="any" @change="handleChange" model="component_value"
        class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"
        :value="convertToFix(disabled ? 0 : this.initValue * this.scale)"
        :disabled="this.checkOverride !== null || disabled" />
    </div>

    <div v-else class="text-left px-6">
      &hyphen;
    </div>

  </div>
</template>

<script>
export default {
  props: [
    "scale",
    "initValue",
    "hideValues",
    "recipePortion",
    "checkOverride",
    'disabled',
    'is_frection',
    'isNearestQuarter'
  ],
  name: "UsdaComponent",
  mounted() {
    // console.log('component_value', this.component_value)
    // console.log('component_value', this.component_value === null) 
    let $this = this;
    // setTimeout(() => { 
    //   // let v = $this.convertToFix($this.initValue * $this.scale);
    //   // const scale = v / $this.initValue;
    //   $this.$emit('changeComponent', $this.scale);

    // }, 1000);     
  },
  data() {
    return {
      component_value: this.$helpers.nearestValue(this.initValue * this.scale, this.isNearestQuarter),
      //closes 0.125
      //component_value: this.initValue * this.scale,
    }
  },
  methods: {
    roundToNearestQuarter(num) {
      return Math.round(num * 4) / 4;
    },
    decimalToFractionNew(decimal) {
      decimal = this.roundToNearestQuarter(decimal);
      const integerPart = Math.floor(decimal);
      const fractionalPart = decimal - integerPart;

      if (fractionalPart === 0) {
        return integerPart.toString(); // Return only the integer part if there's no fraction
      }

      // Convert the fractional part to a fraction
      const tolerance = 1.0E-6;  // Tolerance for floating-point precision
      let numerator = 1;
      let denominator = 1;
      let fraction = fractionalPart;

      while (Math.abs(fraction - Math.round(fraction)) > tolerance) {
        denominator++;
        fraction = fractionalPart * denominator;
        numerator = Math.round(fraction);
      }

      return `${integerPart} ${numerator}/${denominator}`;
    },
    convertToFix(vals) {
      if (vals > 0 && this.isFloat(vals)) {
        return this.$helpers.nearestValue(vals, this.isNearestQuarter);
      } else {
        return vals;
      }
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    },
    handleChange(event) {

      event.target.value = this.$helpers.nearestValue(event.target.value, this.isNearestQuarter);
      const scale = event.target.value / this.initValue;
      this.$emit('changeComponent', scale);
    }
  }
}
</script>

<style scoped>
input:disabled {
  background: #ccc;
}
</style>
